/** Copy bounded UTF-16 units so diagnostics cannot retain a large source string. */
export function boundedText(value: string, maxCharacters: number): string {
  return value.slice(0, maxCharacters).split('').join('');
}

function isInspectionObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

/** Bounded diagnostic values, never complete feeds or executable replay data. */
export function summarize(value: unknown, maxCharacters: number): unknown {
  function visit(item: unknown, depth: number): unknown {
    if (typeof item === 'string') return boundedText(item, 200);
    if (item === null || typeof item === 'number' || typeof item === 'boolean')
      return item;
    if (typeof item === 'object' && item !== null)
      return collection(item, depth);
    return `[${typeof item}]`;
  }
  function collection(item: unknown, depth: number): unknown {
    if (Array.isArray(item)) {
      return {
        length: item.length,
        items:
          depth === 0
            ? undefined
            : item.slice(0, 8).map((entry) => visit(entry, depth - 1)),
      };
    }
    if (depth === 0 || !isInspectionObject(item)) return '[object]';
    const entries: Array<[string, unknown]> = [];
    for (const key in item) {
      if (!Object.hasOwn(item, key)) continue;
      const value = item[key];
      entries.push([boundedText(key, 120), visit(value, depth - 1)]);
      if (entries.length === 20) break;
    }
    return Object.fromEntries(entries);
  }
  const result = visit(value, 4);
  const json = JSON.stringify(result);
  return json.length <= maxCharacters
    ? result
    : {
        truncated: true,
        preview: boundedText(json, Math.floor((maxCharacters - 50) / 6)),
      };
}
